import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bscarousel',
	templateUrl:'./BSCarouselPage.html',
	styles: [],
	styleUrls:['./BSCarouselPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSCarouselPage
{
	mdContent_83 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.carousel.BSCarousel;
\`\`\``;
	mdContent_84 = `\`\`\`java
new BSCarousel<>()
\`\`\``;
	mdContent_85 = `\`\`\`java
var carousel = new MyCarousel();
carousel.setInterval(3000);
carousel.setShowNavigationArrows(true);
carousel.setShowNavigationIndicators(true);

var slide1 = new BSCarouselSlide<>();
slide1.add(new Image<>("/images/slide1.jpg"));

var slide2 = new BSCarouselSlide<>();
slide2.add(new Image<>("/images/slide2.jpg"));

carousel.addSlide(slide1);
carousel.addSlide(slide2);
\`\`\``;
}
